import(/* webpackMode: "eager" */ "/usr/src/app/partner-portal/src/app/[lang]/error.tsx")